import { useCallback, useMemo, useRef, useState } from "react";
import { PopoverOrigin, useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { useDispatch, useSelector } from "react-redux";
import { actions, selectors } from "redux-store";
import { LanguageValues } from "models/Language";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuIcon: {
      width: 44,
      height: 44,
      marginRight: 20,
      padding: 10,
      [theme.breakpoints.down("sm")]: {
        marginRight: 5,
      },
    },
    popover: {
      background: "#673368",
      color: "white",
      width: 200,
    },
    menuItem: {
      padding: "2px 20px",
    },
    flagContainer: {
      padding: "5px",
    },
    flag: {
      width: 28,
      height: 20,
      borderRadius: 5,
    },
  }),
);

const useLanguageMenu = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(
    () => ({
      popoverPaper: {
        paper: styles.popover,
      },
    }),
    [styles],
  );
  const anchorOrigin = useMemo<PopoverOrigin>(
    () => ({ vertical: "bottom", horizontal: "right" }),
    [],
  );

  const transformOrigin = useMemo<PopoverOrigin>(
    () => ({ vertical: "top", horizontal: "right" }),
    [],
  );
  const atomicStyles = useAtomicStyles();
  const anchorRef = useRef();
  const [isLanguageSelectorMenuOpen, setIsLanguageSelectorMenuOpen] = useState(
    false,
  );
  const handleLanguageSelectorMenuOpen = useCallback(
    () => setIsLanguageSelectorMenuOpen(true),
    [],
  );
  const handleLanguageSelectorMenuClose = useCallback(
    () => setIsLanguageSelectorMenuOpen(false),
    [],
  );
  const currentUserLanguage = useSelector(selectors.getUserLanguage);
  const dispatch = useDispatch();

  const handleListItemClick = useMemo(
    () =>
      Object.keys(LanguageValues).map((languageKey) => {
        return () => {
          dispatch(actions.setUserLanguage(LanguageValues[languageKey]));
          setIsLanguageSelectorMenuOpen(false);
        };
      }),
    [dispatch],
  );

  return {
    styles,
    classes,
    anchorOrigin,
    transformOrigin,
    atomicStyles,
    anchorRef,
    isLanguageSelectorMenuOpen,
    handleLanguageSelectorMenuOpen,
    handleLanguageSelectorMenuClose,
    handleListItemClick,
    currentUserLanguage,
  };
};

export { useLanguageMenu as default };
